<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Edit Sponsor</h2>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>Sponsor Information</h3>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'Sponsor Name'"
          [type]="'text'"
          [placeholder]="'Enter sponsor name'"
          [(value)]="sponsor_name"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'Sponsor Description'"
          [type]="'text'"
          [placeholder]="'Enter sponsor description'"
          [(value)]="sponsor_description"
        />
      </div>
    </div>

    <div class="row spacing-30">
      <div class="col-12">
        <h4>Logo</h4>
        @if (sponsor.logo_url) {
          <div class="mb-3 d-flex align-items-center">
            <span class="me-3 text-muted">Current:</span>
            <img [src]="sponsor.logo_url" alt="Current logo" style="max-width: 150px; max-height: 150px; object-fit: contain; border: 1px solid #e0e0e0; border-radius: 4px; padding: 8px;">
          </div>
        }
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="onLogoSelected($event)"
        />
        @if (logoPreview) {
          <div class="mt-3 d-flex align-items-center">
            <span class="me-3 text-success">New:</span>
            <img [src]="logoPreview" alt="New logo" style="max-width: 150px; max-height: 150px; object-fit: contain; border: 1px solid #4caf50; border-radius: 4px; padding: 8px;">
          </div>
        }
      </div>
    </div>

    <div class="row spacing-30">
      <div class="col-12">
        <h4>Banner Image</h4>
        @if (sponsor.image_url) {
          <div class="mb-3 d-flex align-items-center">
            <span class="me-3 text-muted">Current:</span>
            <img [src]="sponsor.image_url" alt="Current banner" style="max-width: 150px; max-height: 150px; object-fit: contain; border: 1px solid #e0e0e0; border-radius: 4px; padding: 8px;">
          </div>
        }
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="onImageSelected($event)"
        />
        @if (imagePreview) {
          <div class="mt-3 d-flex align-items-center">
            <span class="me-3 text-success">New:</span>
            <img [src]="imagePreview" alt="New banner" style="max-width: 150px; max-height: 150px; object-fit: contain; border: 1px solid #4caf50; border-radius: 4px; padding: 8px;">
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="'Update Sponsor'"
          [iconClass]="'fa fa-save'"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
